import React from "react";

const OneOnOnes = () => {
  return (
    <div>
      <p>one on 1s</p>
    </div>
  );
};

export default OneOnOnes;
